import React, { useEffect, useState, useRef } from "react";
import clsx from "clsx";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import { Collapse, makeStyles } from "@material-ui/core";
import { useInView } from "react-intersection-observer";
import { motion } from "framer-motion";

import SEO from "../../components/SEO";
import Link from "../../components/v2/Link";
import LazyImage from "../../components/v4/LazyLoadImage/LazyImage";
import ClientScroll from "../../components/v4/clientScroll/ClientScroll";
import FaqSection from "../../components/v4/FaqSection/FaqSection";
import TruestedSection from "../../components/v4/TrustedSection/TruestedSection";
import TestimonialSlider from "../../components/v3/TestimonialSlider/TestimonialSlider";

import greenCheckCircle from "../../images/v4/whatsappPage/icons/greenCheckCircle.svg";

import downArrow from "../../images/v4/aiPage/icons/downArrow.svg";

import heroSectionImage from "../../images/v4/whatsappAd/images/heroSectionImage.webp";
import whatIsAd from "../../images/v4/whatsappAd/images/whatIsAd.webp";

import clientLogo1 from "../../images/v4/salesReps/clientLogo/transparentLogos/client1.png";
import clientLogo2 from "../../images/v4/salesReps/clientLogo/transparentLogos/client2.png";
import clientLogo3 from "../../images/v4/salesReps/clientLogo/transparentLogos/client3.png";
import clientLogo4 from "../../images/v4/salesReps/clientLogo/transparentLogos/client4.png";
import clientLogo5 from "../../images/v4/salesReps/clientLogo/transparentLogos/client5.png";
import clientLogo6 from "../../images/v4/salesReps/clientLogo/transparentLogos/client6.png";
import clientLogo7 from "../../images/v4/salesReps/clientLogo/transparentLogos/client7.png";

import benefitIcon1 from "../../images/v4/whatsappAd/icons/benefitIcon1.svg";
import benefitIcon2 from "../../images/v4/whatsappAd/icons/benefitIcon2.svg";
import benefitIcon3 from "../../images/v4/whatsappAd/icons/benefitIcon3.svg";
import benefitIcon4 from "../../images/v4/whatsappAd/icons/benefitIcon4.svg";
import benefitIcon5 from "../../images/v4/whatsappAd/icons/benefitIcon5.svg";
import benefitIcon6 from "../../images/v4/whatsappAd/icons/benefitIcon6.svg";

import experienceImg1 from "../../images/v4/whatsappAd/images/exp1.webp";
import experienceImg2 from "../../images/v4/whatsappAd/images/exp2.webp";
import experienceImg3 from "../../images/v4/whatsappAd/images/exp3.webp";
import experienceImg4 from "../../images/v4/whatsappAd/images/exp4.webp";
import experienceImg5 from "../../images/v4/whatsappAd/images/exp5.webp";

import gradebg1 from "../../images/v4/whatsappAd/images/gradebg1.png";
import gradebg2 from "../../images/v4/whatsappAd/images/gradebg2.png";
import gradebg3 from "../../images/v4/whatsappAd/images/gradebg3.png";
import gradebg4 from "../../images/v4/whatsappAd/images/gradebg4.png";
import gradebg5 from "../../images/v4/whatsappAd/images/gradebg5.png";

import realWorldImage1 from "../../images/v4/whatsappAd/images/realWorldImage1.webp";
import realWorldImage2 from "../../images/v4/whatsappAd/images/realWorldImage2.webp";
import realWorldImage3 from "../../images/v4/whatsappAd/images/realWorldImage3.webp";
import realWorldImage4 from "../../images/v4/whatsappAd/images/realWorldImage4.webp";
import realWorldImage5 from "../../images/v4/whatsappAd/images/realWorldImage5.webp";

import compareItemImg1 from "../../images/v4/whatsappAd/images/compareItemImg1.webp";
import compareItemImg2 from "../../images/v4/whatsappAd/images/compareItemImg2.webp";
import compareItemImg3 from "../../images/v4/whatsappAd/images/compareItemImg3.webp";
import compareItemImg4 from "../../images/v4/whatsappAd/images/compareItemImg4.webp";
import compareItemImg5 from "../../images/v4/whatsappAd/images/compareItemImg5.webp";

import leadCaptureIcon from "../../images/v4/industryPage/leadCpature.png";
import quatationIcon from "../../images/v4/industryPage/quatation.png";
import contactManagemntIcon from "../../images/v4/industryPage/contactManagement.png";
import pipelineIcon from "../../images/v4/industryPage/pipeline.png";
import omniChannelIcon from "../../images/v4/industryPage/omnichannel.png";
import emailMarketingIcon from "../../images/v4/industryPage/emailmarketing.png";
import salesForecastIcon from "../../images/v4/industryPage/salesForecast.png";
import opportunityMangeIcon from "../../images/v4/industryPage/opportunityManagement.png";
import aiChatbotIcon from "../../images/v4/industryPage/aiChatbot.png";
import whatsappCrmIcon from "../../images/v4/industryPage/whatsappCrm.png";
import mobileCrmIcon from "../../images/v4/industryPage/mobileCrm.png";
import utmTrackingIcon from "../../images/v4/industryPage/utmTracking.png";
import realTimeDashboardIcon from "../../images/v4/industryPage/realTimeDashboard.png";
import voipToolIcon from "../../images/v4/industryPage/voipTool.png";
import videoConferencingIcon from "../../images/v4/industryPage/videoConference.png";

import salesdevpageHerobg from "../../images/v4/TgPages/salesDevReps/saleslogobg.png";

import bannerTick from "../../images/v4/salesReps/heroTick.svg";

import benefitSectionBg from "../../images/v4/whatsappAd/images/benefitSectionBg.png";
import heroSectionBg from "../../images/v4/whatsappAd/images/heroSectionBg.png";
import topIndustiesBg from "../../images/v4/whatsappAd/images/topIndustiesBg.png";
import whatIsBg from "../../images/v4/whatsappAd/images/whatIsBg.png";
import accordianTabsBg from "../../images/v4/whatsappAd/images/accordianTabsBg.png";
import useCaseBg from "../../images/v4/whatsappAd/images/useCaseBg.png";

const useStyles = makeStyles((theme) => ({
  whatsappSection: {
    backgroundImage: `url(${heroSectionBg})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    paddingTop: "80px",
    "& $aiSectionLeft": {
      width: "50%",
      gap: "32px",
    },
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
      marginTop: "70px",
    },
    "@media only screen and (max-width: 600px)": {
      "& $aiSectionLeft": {
        width: "100%",
      },
      paddingTop: "0px",
      "& .centerContainer": {
        width: "100%",
        marginTop: "30px",
      },
      "& .container": {
        paddingBottom: "40px",
      },
      "& .buttonContaienr": {
        "& .primaryButton": {
          width: "100%",
        },
      },
    },
  },
  aiSectionContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      gap: "20px",
    },
  },
  aiSectionLeft: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    width: "40%",
    gap: "20px",
    "& .highlighterText": {
      background: "linear-gradient(90deg, #7AFFAB 0%, #80C8FF 100%)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  aiSectionRight: {
    width: "45%",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  listContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "24px",
  },
  listItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "15px",
    color: "#A2BED3",
  },
  integrationLeft: {
    width: "42%",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  integrationRight: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    width: "50%",
    gap: "20px",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  benefitSection: {
    backgroundImage: `url(${whatIsBg})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    "& $integrationLeft": {
      width: "45%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      gap: "10px",
    },
    "& $integrationHeader": {
      justifyContent: "space-around",
      alignItems: "center",
    },
    "@media only screen and (max-width: 600px)": {
      "& $integrationHeader": {
        flexDirection: "column-reverse",
      },
      "& $integrationLeft": {
        width: "100%",
      },
      "& $integrationRight": {
        width: "100%",
      },
    },
  },
  benefitSection2: {
    backgroundImage: `url(${benefitSectionBg})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    "& .centerContainer": {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      gap: "32px",
      width: "100%",
      margin: "0 auto",
      "& h2": {
        width: "50%",
        textAlign: "left",
      },
      "& p": {
        textAlign: "left",
        width: "40%",
      },
      "@media only screen and (max-width: 600px)": {
        flexDirection: "column",
        gap: "16px",
        "& h2": {
          width: "100%",
          textAlign: "left",
        },
        "& p": {
          textAlign: "left",
          width: "100%",
        },
      },
    },
  },
  integrationRightImage: {
    "& img": {
      width: "100%",
    },
  },
  integrationHeader: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    width: "100%",
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      gap: "30px",
    },
  },
  benefitContainer: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "24px",
    rowGap: "24px",
    margin: "60px 0",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "32px",
    },
  },
  benefitBox: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "24px",
    width: "32%",
    padding: "24px",
    borderRadius: "16px",
    transition: "0.3s ease",
    background: "transparent",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "12px",
      padding: "0",
    },
    // "&:hover": {
    //   transition: "0.3s ease",
    //   background: "linear-gradient(117deg, #F2E1FF 0.97%, #E9FFFF 100%)",
    //   "@media only screen and (max-width: 600px)": {
    //     "&:hover": {
    //       background: "transparent",
    //     },
    //   },
    // },
  },
  experienceContainer: {
    position: "relative",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    "& .centerContainer": {
      width: "70%",
      margin: "0 auto",
      textAlign: "center",
      "@media only screen and (max-width: 1024px)": {
        width: "80%",
      },
      "@media only screen and (max-width: 768px)": {
        width: "90%",
      },
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
  },
  experienceInnerContainer: {
    display: "flex",
    alignItems: "stretch",
    justifyContent: "space-between",
    width: "100%",
    marginTop: "20px",
    gap: "40px",
    "@media only screen and (max-width: 1024px)": {
      gap: "30px",
    },
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      gap: "40px",
      alignItems: "center",
    },
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      gap: "20px",
      alignItems: "flex-start",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "15px",
    },
  },
  experienceContainerLeft: {
    width: "40%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "16px",
    "& .exp-desc": {
      marginBottom: "24px",
    },
    "& .view-more-link": {
      textDecoration: "underline",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      gap: "10px",
      "& img": {
        display: "inline-block!important",
        width: "16px!important",
        height: "16px",
        marginTop: "3px!important",
        transition: "transform 0.5s ease",
      },
      "&:hover": {
        color: "#010F1D",
        "& img": {
          transform: "translateX(5px)",
        },
      },
    },
    "@media only screen and (max-width: 1024px)": {
      width: "50%",
      gap: "20px",
    },
    "@media only screen and (max-width: 768px)": {
      width: "100%",
      gap: "24px",
      alignItems: "center",
      textAlign: "center",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      marginTop: "30px",
      alignItems: "flex-start",
      textAlign: "left",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "18px",
    },
  },
  experienceContainerRight: {
    width: "60%",
    minHeight: "450px",

    "@media only screen and (max-width: 768px)": {
      display: "none",
    },
    "& .rightContent": {
      padding: "32px",
      gap: "46px",
      borderRadius: "16px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
      height: "100%",
      "& p": {
        color: "#fff",
      },
      "& img": {
        width: "100%",
      },
    },
  },
  faqHeading: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    "@media only screen and (max-width: 1024px)": {
      gap: "15px",
    },
    "@media only screen and (max-width: 768px)": {
      gap: "12px",
    },
    "@media only screen and (max-width: 600px)": {
      "& h3": {
        textAlign: "left",
      },
      gap: "10px",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "8px",
    },
  },
  downArrow: {
    transition: "0.3s ease",
    "&.active": {
      transform: "rotate(180deg)",
    },
  },
  collapseBody: {
    display: "none",
    margin: "0",
    "& img": {
      display: "none",
    },
    "@media only screen and (max-width: 1024px)": {
      margin: "8px 0 0",
    },
    "@media only screen and (max-width: 768px)": {
      margin: "6px 0 0",
      display: "block",
      "& img": {
        display: "block",
        width: "100%",
        marginTop: "12px",
        padding: "16px",
        borderRadius: "16px",
        overflow: "hidden",
      },
    },
    "@media only screen and (max-width: 600px)": {
      "& img": {
        display: "block",
        width: "100%",
        marginTop: "15px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      margin: "5px 0 0",
      "& img": {
        marginTop: "10px",
      },
    },
  },
  body: {
    textAlign: "left",
    margin: "10px 0  ",
    "& img": {
      display: "none",
    },
    "@media only screen and (max-width: 1024px)": {
      margin: "8px 0 0",
    },
    "@media only screen and (max-width: 768px)": {
      margin: "6px 0 0",
      "& img": {
        display: "block",
        width: "100%",
        marginTop: "12px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      "& img": {
        display: "block",
        width: "100%",
        marginTop: "15px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      margin: "5px 0 0",
      "& img": {
        marginTop: "10px",
      },
    },
  },

  accordianTabs: {
    backgroundImage: `url(${accordianTabsBg})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    position: "relative",
    "& .headercenterContainer": {
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "flex-start",
      marginBottom: "64px",
      flexDirection: "column",
      gap: "32px",
      width: "100%",
      "& h2": {
        width: "60%",
      },
      "& p": {
        width: "50%",
      },
      "@media only screen and (max-width: 768px)": {
        flexDirection: "column",
        gap: "24px",
        "& h2": {
          width: "100%",
          textAlign: "center",
        },
        "& p": {
          width: "100%",
          textAlign: "center",
        },
      },
    },
  },
  experienceHeader: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    flexDirection: "column",
    "@media(max-width:768px)": {
      "& p": {
        display: "none",
      },
    },
  },
  faqBoxAccordian: {
    padding: "16px 24px",
    background: "#fff",
    borderRadius: "16px",
    position: "relative",
    transition: "all 0.3s ease",
    overflow: "hidden",
    width: "100%",
    "&:after": {
      content: '""',
      position: "absolute",
      left: "0",
      top: "0",
      width: "100%",
      height: "1px",
      background: "rgb(255, 255, 255)",
    },
    "&:before": {
      content: '""',
      position: "absolute",
      background: "#B1DBFF",
      background:
        "linear-gradient(90deg,rgba(32, 142, 236, 1) 25%, rgba(158, 90, 213, 1) 54%, rgba(255, 255, 255, 1) 80%)",
      left: "-16px",
      borderRadius: "16px",
      top: "0",
      width: "100%",
      height: "2px",
      transform: "scaleX(0) scaleY(1)",
      transformOrigin: "left",
      zIndex: 1,
    },
    "&.active": {
      background: "linear-gradient(270deg, #F8FCFF 0%, #E0EFFD 100%)",
      "&:before": {
        animation: "growTimerY 10s linear forwards", // Same as JS interval
      },
    },
    "& .body": {
      margin: "0",
    },
    "& .exp-desc": {
      margin: "10px 0 16px",
      whiteSpace: "nowrap",
      maxWidth: "100%",
      overflow: "hidden",
      textOverflow: "ellipsis",
      "@media(max-width:768px)": {
        whiteSpace: "normal",
        overflow: "visible",
        textAlign: "left",
        textOverflow: "unset",
      },
    },
  },
  combineSection: {
    position: "relative",
    paddingTop: "64px",
    backgroundImage: `url(${salesdevpageHerobg})`,
    backgroundSize: "cover",
    paddingBottom: "220px",
    "@media(max-width:600px)": {
      paddingBottom: "90px",
    },
  },
  integrationContent: {
    width: "100%",
    textAlign: "center",
    color: "#fff",
    maxWidth: "1200px",
    margin: "0 auto 32px",

    "& h2": {
      marginBottom: "16px !important",
      marginTop: "0 !important",
    },
    "& p": {
      marginBottom: "16px",
      textAlign: "left",
      paddingRight: "80px",
    },
    "@media only screen and (max-width: 1024px)": {
      "& p": {
        paddingRight: "40px",
        fontSize: "18px",
      },
    },
    "@media only screen and (max-width: 768px)": {
      "& p": {
        paddingRight: "0",
        textAlign: "center",
        fontSize: "16px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      marginBottom: "20px",
      "& p": {
        fontSize: "14px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      "& p": {
        fontSize: "13px",
      },
    },
  },
  absoulteCard: {
    position: "absolute",
    margin: "0 auto",
    width: "100%",
    top: "100%",
    transform: "translate(-50% ,-50%)",
    left: "50%",
    right: "0",
  },
  realWorldTabs: {
    backgroundImage: `url(${useCaseBg})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    paddingTop: "300px",
    "& h2": {
      textAlign: "center",
    },
    "& .container": {
      padding: "0 0 120px",
    },
    "@media only screen and (max-width: 1024px)": {
      paddingTop: "250px",
      "& .container": {
        padding: "0 24px 65px",
      },
    },
    "@media only screen and (max-width: 768px)": {
      paddingTop: "280px",
    },
    "@media only screen and (max-width: 600px)": {
      paddingTop: "150px",
      "& .container": {
        padding: "40px 15px !important",
      },
    },

    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "100%",
      margin: "0 auto",
      textAlign: "center",
      "& h2": {
        width: "80%",
      },
    },
    "@media only screen and (max-width: 1200px)": {
      "& .centerContainer": {
        "& h2": {
          width: "100% !important",
        },
      },
    },
  },
  tabsContainer: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "8px",
    border: "2px solid #DBDBDB",
    borderRadius: "40px",
    background: "#fff",
    overflow: "auto",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      padding: "5px",
    },
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  tab: {
    width: "33%",
    background: "",
    padding: "18px",
    background: "transparent",
    borderRadius: "40px",
    background: "transparent",
    transition: "0.3s ease",
    cursor: "pointer",
    "&.active": {
      color: "white",
      background:
        "linear-gradient(90deg, #FF682A 0%, #FF7056 35%, #FF682A 73%, #FF550F 100%)",
    },
    "@media only screen and (max-width: 600px)": {
      minWidth: "max-content",
      padding: "10px",
    },
  },
  tabCard: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    marginTop: "32px",
    gap: "40px",
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      gap: "40px",
    },
  },
  tabCardLeftContainer: {
    display: "flex",
    gap: "40px",
    flexDirection: "column",
    alignItems: "flex-start",
    "@media only screen and (max-width: 768px)": {
      alignItems: "center",
      width: "100%",
    },
  },
  benfitListContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "30px",
    marginTop: "50px",
    "@media only screen and (max-width: 600px)": {
      gap: "15px",
      marginTop: "20px",
    },
  },
  benfitListItem: {
    display: "flex",
    width: "100%",
    margin: "0 auto",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "15px",
    position: "relative",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "15px",
      alignItems: "flex-start",
    },
  },
  benfitListItemContent: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    gap: "10px",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  benfitIcon: {
    width: "24px!important",
    "& img": {
      width: "100%",
      marginTop: "6px",
    },
    "@media only screen and (max-width: 600px)": {
      width: "24px!important",
    },
  },

  commonPageFooterSection: {
    background:
      "transparent linear-gradient(90deg, #011D32 0%, #00182B 100%) 0% 0% no-repeat padding-box",
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
    },
    "@media only screen and (max-width: 1024px)": {
      "& .centerContainer": {
        width: "90%",
        gap: "28px",
      },
    },
    "@media only screen and (max-width: 768px)": {
      "& .centerContainer": {
        width: "95%",
        gap: "24px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      "& .centerContainer": {
        width: "100%",
        gap: "20px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      "& .centerContainer": {
        gap: "16px",
      },
    },
  },
  compareSectionContainer: {
    gap: "40px",
    display: "flex",
    marginTop: "60px",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    position: "relative",
    "@media only screen and (max-width: 1024px)": {
      gap: "30px",
      marginTop: "50px",
    },
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      marginTop: "30px",
      gap: "20px",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "15px",
      marginTop: "20px",
    },
  },
  compareSectionContainerLeftSection: {
    width: "30%",
    position: "sticky",
    top: "100px",
    "@media only screen and (max-width: 1024px)": {
      width: "35%",
      top: "80px",
    },
    "@media only screen and (max-width: 768px)": {
      width: "100%",
      position: "static",
      display: "none",
    },
  },
  compareSectionLeftItem: {
    padding: "15px 20px",
    borderLeft: "5px solid transparent",
    transition: "0.3s ease",
    "&.active": {
      borderLeft: "5px solid #02AE7F",
    },
    "& a": {
      textDecoration: "none",
      color: "#000",
    },
    "@media only screen and (max-width: 1024px)": {
      padding: "12px 16px",
    },
    "@media only screen and (max-width: 768px)": {
      padding: "10px 14px",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "8px 12px",
    },
    "@media only screen and (max-width: 480px)": {
      padding: "6px 10px",
    },
  },
  compareSectionContainerRightSection: {
    width: "70%",
    "@media only screen and (max-width: 1024px)": {
      width: "65%",
    },
    "@media only screen and (max-width: 768px)": {
      width: "100%",
    },
  },
  compareItemContainer: {
    marginBottom: "60px",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    flexDirection: "column",
    gap: "20px",
    "& .productImage": {
      width: "100%",
    },
    "&:last-child": {
      marginBottom: 0,
    },
    "@media only screen and (max-width: 1024px)": {
      marginBottom: "50px",
      gap: "18px",
    },
    "@media only screen and (max-width: 768px)": {
      marginBottom: "40px",
      gap: "16px",
    },
    "@media only screen and (max-width: 600px)": {
      marginBottom: "30px",
      gap: "15px",
    },
    "@media only screen and (max-width: 480px)": {
      marginBottom: "25px",
      gap: "12px",
    },
  },
  faqBox: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    borderBottom: "1px solid #B7B7B7",
    width: "100%",
    "&:first-child": {
      borderTop: "1px solid #B7B7B7",
      paddingTop: "15px",
    },
    "@media only screen and (max-width: 768px)": {
      marginBottom: "15px",
    },
    "@media only screen and (max-width: 600px)": {
      marginBottom: "12px",
    },
  },
  faqsContainer: {
    marginTop: "60px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "15px",
    cursor: "pointer",
    width: "100%",
    "@media only screen and (max-width: 768px)": {
      marginTop: "20px",
    },
    "@media only screen and (max-width: 600px)": {
      marginTop: "15px",
    },
  },
  topFiveHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
  },
  testimonials: {
    background: "#e9f4fe",
    paddingBottom: "50px",
    "@media(max-width:1025px)": {
      paddingBottom: "24px",
    },
  },
  commonPageFooterSection: {
    background:
      " linear-gradient(90deg, #011D32 0%, #00182B 100%) 0% 0% no-repeat padding-box",
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
    },
    "@media only screen and (max-width: 600px)": {
      "& .centerContainer": {
        width: "100%",
      },
    },
  },
  wpFaq: {
    // paddingTop: "120px",
    "@media only screen and (max-width: 600px)": {
      "& section": {
        padding: "0px 0 0 !important",
      },
    },
  },
}));

const clickToWhatsAppAds = () => {
  const classes = useStyles();
  const AUTO_PLAY_INTERVAL = 10000;
  const sectionRef = useRef(null);
  const timeoutRef = useRef(null);
  const isInViewRef = useRef(false); //
  const [activeAccordian, setActiveAccordian] = useState(0);
  const [activeRealWorld, setActiveRealWorld] = useState(0);
  const [activeCompare, setActiveCompare] = useState("#section0");
  const clientScrollData = {
    title: "Trusted by top brands across industries",
    backgroundImage: "",
    logos: [
      {
        img: clientLogo1,
      },
      {
        img: clientLogo2,
      },
      {
        img: clientLogo3,
      },
      {
        img: clientLogo4,
      },
      {
        img: clientLogo5,
      },
      {
        img: clientLogo6,
      },
      {
        img: clientLogo7,
      },
    ],
    directions: ["left", "right", "left"],
    speeds: [0.8, 0.4, 0.8],
  };
  const benefits = [
    {
      title: "Instant connection",
      desc: "Allow potential customers to initiate conversations with your business immediately after seeing an ad, enabling seamless engagement.",
      icon: benefitIcon1,
    },
    {
      title: "Higher engagement rates",
      desc: "The familiar and personal nature of WhatsApp often leads to better engagement compared to traditional ad formats.",
      icon: benefitIcon2,
    },
    {
      title: "Improved customer service",
      desc: "Provide real-time support and address queries promptly, enhancing customer satisfaction through instant communication.",
      icon: benefitIcon3,
    },
    {
      title: "Increased conversion potential",
      desc: "Direct, personalised communication can effectively guide customers through the sales funnel and boost conversion rates.",
      icon: benefitIcon4,
    },
    {
      title: "Cost-effective advertising",
      desc: "Pay only for ads that result in actual conversations, optimising your marketing budget for maximum impact.",
      icon: benefitIcon5,
    },
    {
      title: "Enhanced targeting",
      desc: "Leverage robust targeting options to ensure your ads reach the most relevant audience for your business.",
      icon: benefitIcon6,
    },
  ];
  const experienceList = [
    {
      title: "Seamless lead capture",
      alt: "WhatsApp booking button for services.",
      lintText: "Learn about lead capture",
      linkUrl: "https://peppercloud.com/whatsapp-crm-lead-capture",
      img: experienceImg1,
      bgImg: gradebg1,
      desc: "Automatically capture leads generated through Click to WhatsApp ads directly into your WhatsApp CRM. This eliminates the risk of missed opportunities and ensures every inquiry is recorded in real time. Follow-ups become faster and more efficient, keeping your sales pipeline active and organised.",
    },
    {
      title: "Instant customer interaction",
      alt: "Contact support with WhatsApp link.",
      lintText: "See how instant chat works",
      linkUrl: "https://peppercloud.com/whatsapp-instant-customer-interaction",
      img: experienceImg2,
      bgImg: gradebg2,
      desc: "Ads that click to WhatsApp enable users to start real-time conversations immediately. This enables immediate engagement, allowing your business to respond faster, build trust, and guide prospects through the sales journey with minimal friction. No delays—just direct, human connection.",
    },
    {
      title: "Automated response triggers",
      alt: "Shop products using WhatsApp ad.",
      lintText: "Automate responses",
      linkUrl: "https://peppercloud.com/whatsapp-automation",
      img: experienceImg3,
      bgImg: gradebg3,
      desc: "Set up intelligent auto-replies for messages received via click to WhatsApp. These automated responses help you stay available 24/7, reduce wait times, and ensure consistent service even when your team is offline. It’s a seamless way to improve response speed and customer satisfaction.",
    },
    {
      title: "Integrated analytics",
      alt: "Ask questions on WhatsApp campaign.",
      lintText: "See analytics in action",
      linkUrl: "https://peppercloud.com/whatsapp-crm-analytics",
      img: experienceImg4,
      bgImg: gradebg4,
      desc: "Get a complete picture of your WhatsApp ads performance with real-time tracking of message volume, engagement quality, response times, and conversion rates—all inside your CRM dashboard. These insights help you understand what’s working and make smarter, data-backed decisions to refine your strategy.",
    },
    {
      title: "Personalised messaging",
      alt: "Ask questions on WhatsApp campaign.",
      lintText: "Discover personalised messaging",
      linkUrl: "https://peppercloud.com/whatsapp-crm-personalisation",
      img: experienceImg5,
      bgImg: gradebg5,
      desc: "Leverage CRM-stored customer data to send highly tailored responses, product recommendations, and offers through Click to WhatsApp ads. This relevance increases engagement, customer satisfaction, and overall conversion rates.",
    },
  ];
  // Clear timeout
  const clearTimer = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  };

  // Schedule next change
  const scheduleNext = () => {
    clearTimer();
    if (!isInViewRef.current) return; // only autoplay if section is visible

    timeoutRef.current = setTimeout(() => {
      setActiveAccordian((prev) => (prev + 1) % experienceList.length);
    }, AUTO_PLAY_INTERVAL);
  };

  // Start/pause autoplay based on scroll visibility
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          isInViewRef.current = true;
          scheduleNext(); // resume autoplay
        } else {
          isInViewRef.current = false;
          clearTimer(); // pause autoplay
        }
      },
      { threshold: 0.3 } // section is considered "in view" when 30% visible
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      observer.disconnect();
      clearTimer();
    };
  }, [experienceList.length]);

  // Reschedule on activeAccordian change
  useEffect(() => {
    scheduleNext();
    return () => clearTimer();
  }, [activeAccordian, experienceList.length]);

  // Handle user click
  const handleAccordionClick = (index) => {
    setActiveAccordian(index);
    // scheduleNext will run via useEffect so this stays open full interval
  };

  const allIcons = [
    {
      img: leadCaptureIcon,
      title: "Auto lead capture",
    },
    {
      img: contactManagemntIcon,
      title: "Contact management",
    },
    {
      img: pipelineIcon,
      title: "Pipeline management",
    },
    {
      img: omniChannelIcon,
      title: "Omnichannel CRM",
    },
    {
      img: emailMarketingIcon,
      title: "Email marketing",
    },
    {
      img: quatationIcon,
      title: "Quotation generation",
    },
    {
      img: salesForecastIcon,
      title: "Sales forecasting",
    },
    {
      img: opportunityMangeIcon,
      title: "Opportunity management",
    },
    {
      img: aiChatbotIcon,
      title: "AI chatbot",
    },
    {
      img: whatsappCrmIcon,
      title: "WhatsApp CRM",
    },
    {
      img: mobileCrmIcon,
      title: "Mobile CRM",
    },
    {
      img: utmTrackingIcon,
      title: "UTM tracking",
    },
    {
      img: realTimeDashboardIcon,
      title: "Real-time dashboard",
    },
    {
      img: voipToolIcon,
      title: "VOIP tool integration",
    },
    {
      img: videoConferencingIcon,
      title: "Video conferencing",
    },
  ];

  // Function to distribute icons across three tracks
  function distributeIcons(icons) {
    // Sort icons alphabetically to ensure consistent distribution
    const sortedIcons = [...icons].sort((a, b) =>
      a.title.localeCompare(b.title)
    );

    const logotrack1 = [];
    const logotrack2 = [];

    sortedIcons.forEach((icon, index) => {
      // Distribute icons based on their index
      switch (index % 2) {
        case 0:
          logotrack1.push(icon);
          break;
        case 1:
          logotrack2.push(icon);
          break;
      }
    });

    return {
      logotrack1,
      logotrack2,
    };
  }

  // Get the distributed icons
  const { logotrack1, logotrack2 } = distributeIcons(allIcons);

  useEffect(() => {
    // Infinite scroll functionality

    class InfiniteScroll {
      constructor(row, speed) {
        this.row = row;
        this.track = row.querySelector(".logos-track");
        this.speed = speed;
        this.position = 0;
        this.direction = row.dataset.direction || "left";
        this.init();
      }

      init() {
        // Clone the track content
        const content = this.track.innerHTML;
        this.track.innerHTML = content + content + content;

        // Calculate total width
        const logos = this.track.querySelectorAll(".logo");
        let totalWidth = 0;
        logos.forEach((logo) => {
          totalWidth +=
            logo.offsetWidth +
            parseInt(getComputedStyle(logo).marginLeft) +
            parseInt(getComputedStyle(logo).marginRight);
        });

        // Set row height
        this.row.style.height = logos[0].offsetHeight + 20 + "px";

        // Set initial position for right-to-left movement
        if (this.direction === "left") {
          this.position = 0;
        } else {
          this.position = -this.track.offsetWidth / 3;
        }

        // Start animation
        this.animate();
      }

      animate() {
        const animate = () => {
          // Update position based on direction
          if (this.direction === "left") {
            this.position -= this.speed;
            // Reset position when one-third of content has scrolled
            const oneThirdWidth = -this.track.offsetWidth / 3;
            if (this.position <= oneThirdWidth) {
              this.position = 0;
            }
          } else {
            this.position += this.speed;
            // Reset position when one-third of content has scrolled
            if (this.position >= 0) {
              this.position = -this.track.offsetWidth / 3;
            }
          }

          this.track.style.transform = `translateX(${this.position}px)`;
          requestAnimationFrame(animate);
        };

        requestAnimationFrame(animate);
      }
    }

    // Initialize all rows with different speeds and directions
    document.querySelectorAll(".logos-row").forEach((row) => {
      const speed = parseFloat(row.dataset.speed) || 1;
      new InfiniteScroll(row, speed);
    });
  }, []);

  const tabContentData = [
    {
      tabContent: [
        {
          heading: "Product recommendations",
          content:
            "Use CRM data to trigger tailored suggestions through click to WhatsApp conversations, driving higher engagement and conversions.",
          alt: "Product recommendations",
        },
        {
          heading: "Order tracking and updates",
          content:
            "Keep customers informed with real-time delivery notifications delivered directly via WhatsApp ads, building trust and improving satisfaction.",
          alt: "Order tracking and updates",
        },
        {
          heading: "Abandoned cart recovery",
          content:
            "Deploy strategic ads that click to WhatsApp to re-engage shoppers and offer personalised incentives, helping recover lost sales.",
          alt: "Abandoned cart recovery",
        },
        {
          heading: "Flash sale alerts",
          content:
            "Send instant WhatsApp notifications about limited-time offers and deals, encouraging faster decision-making and boosting conversions.",
          alt: "Flash sale alerts",
        },
      ],
      image: realWorldImage1,
      alt: "Discount available on WhatsApp ad.",
      subtitle:
        "Enhance the customer shopping experience and boost sales through personalised interactions, timely updates, and proactive re-engagement on WhatsApp.",
    },
    {
      tabContent: [
        {
          heading: "Appointment booking and reminders",
          content:
            "Let patients instantly schedule or reschedule appointments through Click-to-WhatsApp ads, reducing wait times and no-shows.",
          alt: "Appointment booking and reminders",
        },
        {
          heading: "Prescription and health info support",
          content:
            "Share timely medication reminders and test reports securely using click to WhatsApp messages.",
          alt: "Prescription and health info support",
        },
        {
          heading: "Wellness program updates",
          content:
            "Send curated tips, plans, and check-ins via WhatsApp ads, promoting healthy lifestyles and continuous engagement.",
          alt: "Wellness program updates",
        },
        {
          heading: "Symptom check and triage",
          content:
            "Use automated WhatsApp chats to help patients describe symptoms and guide them to the appropriate care pathway.",
          alt: "Symptom check and triage",
        },
      ],
      image: realWorldImage2,
      alt: "Send inquiry using WhatsApp button.",
      subtitle:
        "Simplify patient engagement and improve service accessibility.",
    },
    {
      tabContent: [
        {
          heading: "Booking assistance",
          content:
            "Use ads that click to WhatsApp to handle travel-related queries instantly, making the planning experience smoother for customers.",
          alt: "Booking assistance",
        },
        {
          heading: "Travel itinerary updates",
          content:
            "Automate itinerary confirmations, check-in reminders, and local travel alerts via click to WhatsApp ads, ensuring a seamless journey.",
          alt: "Travel itinerary updates",
        },
        {
          heading: "Local recommendations",
          content:
            "Share personalised offers, guides, and last-minute deals using your WhatsApp CRM, enhancing guest satisfaction.",
          alt: "Local recommendations",
        },
        {
          heading: "Customer feedback collection",
          content:
            "Prompt guests to share reviews and feedback post-trip via WhatsApp, helping improve future services.",
          alt: "Customer feedback collection",
        },
      ],
      image: realWorldImage3,
      alt: "WhatsApp order now promotional ad.",
      subtitle:
        "Deliver convenient, real-time support throughout the customer journey.",
    },
    {
      tabContent: [
        {
          heading: "Product education and queries",
          content:
            "Launch Click-to-WhatsApp ads that allow users to instantly ask questions about loans, policies, or investment plans.",
          alt: "Product education and queries",
        },
        {
          heading: "Real-time support and alerts",
          content:
            "Use click to WhatsApp to send payment reminders, fraud alerts, or transaction updates directly to users.",
          alt: "Real-time support and alerts",
        },
        {
          heading: "Lead capture and qualification",
          content:
            "Automatically collect and qualify leads from WhatsApp ads and nurture them within your CRM with personalised follow-ups.",
          alt: "Lead capture and qualification",
        },
        {
          heading: "Document collection and updates",
          content:
            "Share or request key documents securely through WhatsApp, speeding up application processes and improving compliance.",
          alt: "Document collection and updates",
        },
      ],
      image: realWorldImage4,
      alt: "Ad promoting WhatsApp quick connect.",
      subtitle:
        "Build trust and improve customer engagement with secure communication.",
    },
    {
      tabContent: [
        {
          heading: "Course information",
          content:
            "Help prospective students learn about courses and enroll instantly via ads that click to WhatsApp, reducing drop-offs and delays.",
          alt: "Course information",
        },
        {
          heading: "Assignment reminders",
          content:
            "Use click to WhatsApp functionality to send alerts about upcoming assignments, ensuring students stay on track.",
          alt: "Assignment reminders",
        },
        {
          heading: "Study resources",
          content:
            "Share quizzes, e-books, and study tips directly via WhatsApp ads, keeping learners engaged and supported at every stage.",
          alt: "Study resources",
        },
        {
          heading: "Doubt resolution",
          content:
            "Enable students to instantly ask questions or clarify concepts through Click-to-WhatsApp ads, ensuring timely academic support.",
          alt: "Doubt resolution",
        },
      ],
      image: realWorldImage5,
      alt: "WhatsApp call-to-action banner",
      subtitle: "Support learners and enhance educational experiences.",
    },
  ];
  const compareItems = [
    "Pepper Cloud CRM",
    "Gallabox",
    "Wati",
    "AiSensy",
    "DelightChat",
  ];
  const compareData = [
    {
      title: "Pepper Cloud CRM",
      desc: "Pepper Cloud CRM stands out as the premier solution for businesses looking to leverage Click-to-WhatsApp ads effectively. This powerful platform seamlessly integrates WhatsApp marketing capabilities with robust CRM features, providing a comprehensive tool for managing customer relationships and driving conversions through WhatsApp ads.",
      img: compareItemImg1,
      alt: "Exclusive offer, WhatsApp chat now.",
      features: [
        {
          title: "Seamless WhatsApp integration",
          desc: "Directly manage WhatsApp conversations within the CRM interface.",
        },
        {
          title: "Advanced lead tracking",
          desc: "Automatically capture and organise leads generated from Click-to-WhatsApp ads.",
        },
        {
          title: "Customisable chat flows",
          desc: "Create personalised conversation paths to guide prospects through your sales funnel.",
        },
        {
          title: "Real-time analytics",
          desc: "Monitor ad performance and conversation metrics to optimise your campaigns.",
        },
        {
          title: "Multi-channel support",
          desc: "Integrate WhatsApp with other communication channels for a unified customer experience.",
        },
        {
          title: "Automated responses",
          desc: "Set up intelligent chatbots with AssistAI to handle common queries and qualify leads.",
        },
        {
          title: "Team collaboration tools",
          desc: "Assign and manage WhatsApp conversations across your sales and support teams.",
        },
        {
          title: "Detailed contact profiles",
          desc: "Build comprehensive customer profiles based on WhatsApp interactions and other touchpoints.",
        },
        {
          title: "Campaign management",
          desc: "Create, manage, and track multiple WhatsApp ad campaigns from a single dashboard.",
        },
        {
          title: "GDPR compliance",
          desc: "Ensure your WhatsApp marketing efforts adhere to data protection regulations.",
        },
      ],
    },
    {
      title: "Gallabox",
      desc: "Gallabox offers a suite of tools for WhatsApp marketing, including support for Click-to-WhatsApp ads.",
      img: compareItemImg2,
      alt: "Chat instantly via WhatsApp button.",
      features: [
        {
          title: "Basic WhatsApp automation",
          desc: "Provides basic WhatsApp automation capabilities for simple customer interactions.",
        },
        {
          title: "Customer segmentation",
          desc: "Offers customer segmentation options to help target specific audience groups.",
        },
        {
          title: "E-commerce integration",
          desc: "Integrates with some e-commerce platforms, allowing for basic order management via WhatsApp.",
        },
        {
          title: "Analytics and reporting",
          desc: "Includes analytics and reporting features for tracking campaign performance.",
        },
      ],
    },
    {
      title: "Wati",
      desc: "Wati is another platform that supports WhatsApp marketing and Click-to-WhatsApp Ads, offering a range of features. It requires prior training for using it efficiently.",
      img: compareItemImg3,
      alt: "Ad showing WhatsApp chat link.",
      features: [
        {
          title: "WhatsApp chatbot builder",
          desc: "Wati includes a chatbot builder specifically designed for WhatsApp conversations.",
        },
        {
          title: "Template message library",
          desc: "The platform provides a template message library to help businesses get started quickly.",
        },
        {
          title: "Basic CRM capabilities",
          desc: "It offers some CRM functionalities, though these may be less extensive than dedicated CRM solutions.",
        },
        {
          title: "Campaign management tools",
          desc: "Includes basic campaign management tools for organising WhatsApp marketing efforts.",
        },
      ],
    },
    {
      title: "AiSensy",
      desc: "AiSensy focusses on AI-powered conversational marketing for WhatsApp, offering innovative features that may be limited in broader applicability.",
      img: compareItemImg4,
      alt: "Click here to message business.",
      features: [
        {
          title: "AI-driven chat automation",
          desc: "The platform utilises AI-driven chat automation to handle customer enquiries.",
        },
        {
          title: "Visual flow builder",
          desc: "AiSensy provides a visual flow builder for creating conversation pathways.",
        },
        {
          title: "Third-party integrations",
          desc: "It offers integration with some third-party tools to extend its functionality.",
        },
        {
          title: "Limited customisation options",
          desc: "The platform may have limited customisation options for businesses with specific needs.",
        },
      ],
    },
    {
      title: "DelightChat",
      desc: "DelightChat provides a customer communication platform that includes WhatsApp integration, though its Click-to-WhatsApp ads capabilities may not be as advanced as dedicated solutions.",
      img: compareItemImg5,
      alt: "WhatsApp contact ad for support.",
      features: [
        {
          title: "Multi-agent inbox",
          desc: "DelightChat offers a multi-agent inbox for team collaboration on WhatsApp communications.",
        },
        {
          title: "Basic chatbot functionality",
          desc: "The platform includes basic chatbot functionality for automating simple customer interactions.",
        },
        {
          title: "E-commerce integration",
          desc: "It provides integration with some e-commerce platforms for managing sales-related conversations.",
        },
        {
          title: "Limited marketing features",
          desc: "DelightChat has limited advanced WhatsApp marketing features compared to specialised solutions.",
        },
      ],
    },
  ];
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 100; // Height of navigation bar
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };

  const faqs = [
    {
      question: "Can I use Click-to-WhatsApp ads for any type of business?",
      answer: (
        <>
          Yes, Click-to-WhatsApp ads can be beneficial for various business
          types, from e-commerce to service-based companies.
        </>
      ),
    },
    {
      question: "How much do Click-to-WhatsApp ads cost?",
      answer: (
        <>
          The cost varies depending on your target audience, ad quality, and
          bidding strategy. You typically pay per click or impression.
        </>
      ),
    },
    {
      question:
        "Are Click-to-WhatsApp ads compliant with data protection regulations?",
      answer: (
        <>
          Yes, when used correctly. Ensure you follow WhatsApp's business
          policies and local data protection laws.
        </>
      ),
    },
    {
      question: "Can I measure the ROI of my Click-to-WhatsApp ads campaigns?",
      answer: (
        <>
          Absolutely. You can track metrics such as click-through rates,
          conversation rates, and conversions to measure your ROI.
        </>
      ),
    },
    {
      question: "How can I integrate Click-to-WhatsApp Ads with my CRM?",
      answer: (
        <>
          Many CRM systems, like Pepper Cloud, offer direct integration with
          WhatsApp. This allows you to capture leads, track conversations, and
          manage customer interactions seamlessly within your CRM.{" "}
          <a href="https://blog.peppercloud.com/facebook-messenger-ads-in-crm/">
            Learn more.
          </a>
        </>
      ),
    },
    {
      question:
        "What are the best practices for running Click-to-WhatsApp ads?",
      answer: (
        <>
          <div>
            <strong>
              To get the most out of your Click-to-WhatsApp ads, follow these
              essential do&#39;s and don&#39;ts:
            </strong>
            <br />
            <br />
            <strong>Do’s:</strong>
            <ul>
              <li>
                Craft clear, concise messages that highlight your value
                proposition.
              </li>
              <li>
                Use high-quality visuals that reflect your brand identity.
              </li>
              <li>
                Segment your audience to deliver more targeted and relevant
                messaging.
              </li>
              <li>
                Respond promptly to incoming WhatsApp messages to maintain
                engagement.
              </li>
              <li>
                Personalise interactions using customer data and preferences.
              </li>
              <li>
                Regularly monitor performance metrics and optimise your
                campaigns accordingly.
              </li>
            </ul>
            <strong>Don’ts:</strong>
            <ul>
              <li>
                Don’t send spammy or irrelevant messages that may annoy users.
              </li>
              <li>Don’t use aggressive or pushy language in your ads.</li>
              <li>
                Don’t overlook customer privacy or violate data protection
                guidelines.
              </li>
              <li>
                Don’t rely on long, impersonal automated responses that
                frustrate users.
              </li>
              <li>
                Don’t forget to train your team on WhatsApp communication best
                practices.
              </li>
              <li>
                Don’t overuse WhatsApp as a marketing channel—respect user
                boundaries to avoid fatigue.
              </li>
            </ul>
            <p>
              By following these best practices, you can create high-performing
              ads that click to WhatsApp and deliver a seamless, engaging
              experience for your audience.
            </p>
          </div>
        </>
      ),
    },
  ];

  return (
    <main>
      <SEO
        title={"Click-to-WhatsApp Ads for Your Sales Businesses | Pepper Cloud"}
        pathname={
          "https://peppercloud.com//whatsapp-crm-feature/free-whatsapp-link-generator/"
        }
        keywords="Click to WhatsApp Ads,click to whatsapp,click to whatsapp ads, ads that click to whatsapp, whatsapp ads"
        description={
          "Explore real-time connections using Pepper Cloud CRM's Click-to-WhatsApp ads campaign and effortlessly bring traffic to your WhatsApp profile using click to WhatsApp ads"
        }
        ogData={{
          "og:image": [
            "/meta/og/1X1/home.png",
            "/meta/og/1024X512/home.png",
            "/meta/og/1200X630/home.png",
          ],
        }}
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "Organization",
          name: "Pepper Cloud",
          legalName: "Pepper Cloud PTE LTD",
          url: "https://peppercloud.com/",
          logo: "https://peppercloud.com/icons/logo.png",
          foundingDate: "2017",
          address: [
            {
              "@type": "PostalAddress",
              streetAddress: "#04-01/02",
              addressLocality: "Blk 79 Ayer Rajah Crescent",
              addressRegion: "SG",
              postalCode: "139955",
              addressCountry: "Singapore",
            },
            {
              "@type": "PostalAddress",
              streetAddress:
                "2nd Floor, Salarpuria Tower 1, 7th Block Koramangala",
              addressLocality: "Bengaluru",
              addressRegion: "KA",
              postalCode: "560095",
              addressCountry: "India",
            },
          ],
          contactPoint: {
            "@type": "ContactPoint",
            contactType: "customer support",
            telephone: "+6566562616",
            email: ["sales@peppercloud.com", "support@peppercloud.com"],
          },
          sameAs: [
            "https://twitter.com/peppercloudpte",
            "https://www.linkedin.com/company/peppercloud/",
            "https://www.facebook.com/PepperCloudPteLtd",
            "https://www.instagram.com/pepper.cloud/",
          ],
        }}
      />
      <section className={classes.whatsappSection}>
        <div className="container">
          <div className={classes.aiSectionContainer}>
            <div className={classes.aiSectionLeft}>
              <motion.h1
                initial={{ opacity: 1, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3 }}
                className="font-wix-semibold font-64 font-white"
              >
                Boost engagement with Click-to-WhatsApp ads
              </motion.h1>
              <motion.p
                initial={{ opacity: 1, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3 }}
                className="font-wix-regular font-18 font-white"
              >
                Engage customers in one tap and capture leads effortlessly
                within WhatsApp CRM. Transform your marketing strategy and
                elevate your business today.
              </motion.p>
              <div className={classes.listContainer}>
                <div className={classes.listItem}>
                  <LazyImage
                    source={greenCheckCircle}
                    alt={"pointer"}
                    className={classes.pointerImg}
                  />
                  <p className="font-wix-regular font-18 font-white">
                    Instantly capture leads when users tap your WhatsApp ad.
                  </p>
                </div>
                <div className={classes.listItem}>
                  <LazyImage
                    source={greenCheckCircle}
                    alt={"pointer"}
                    className={classes.pointerImg}
                  />
                  <p className="font-wix-regular font-18 font-white">
                    Engage customers in real-time through WhatsApp chats.
                  </p>
                </div>
                <div className={classes.listItem}>
                  <LazyImage
                    source={greenCheckCircle}
                    alt={"pointer"}
                    className={classes.pointerImg}
                  />
                  <p className="font-wix-regular font-18 font-white">
                    Track conversions effortlessly within your CRM.
                  </p>
                </div>
              </div>
              <div className="buttonContaienr">
                <Link
                  className="primaryButton font-16 font-wix-medium font-white"
                  to="/contact/?utm_source=WhatsApp+CRM&utm_medium=Get+started"
                >
                  Book a free demo
                </Link>
              </div>
            </div>
            <motion.div
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className={classes.aiSectionRight}
            >
              <LazyImage
                source={heroSectionImage}
                width={"100%"}
                alt={"Ask questions on WhatsApp campaign."}
              />
            </motion.div>
          </div>
        </div>
      </section>
      <ClientScroll
        {...clientScrollData}
        background={topIndustiesBg}
        darkLayout={true}
      />
      <section className={clsx(classes.benefitSection)}>
        <div className="container">
          <div className={classes.integrationHeader}>
            <div className={classes.integrationRight}>
              <LazyImage
                source={whatIsAd}
                alt="WhatsApp chat for customer help."
                className={classes.integrationRightImage}
              />
            </div>
            <div className={classes.integrationLeft}>
              <motion.div
                initial={{ opacity: 1, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3 }}
                className="sectionTag"
              ></motion.div>
              <motion.h2
                initial={{ opacity: 1, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3 }}
                className="font-wix-semibold font-56 color-black1"
              >
                What are Click-to-WhatsApp ads?
              </motion.h2>
              <motion.p
                initial={{ opacity: 1, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3 }}
                className="font-wix-regular font-18 color-black2 mt20"
              >
                Click-to-WhatsApp ads are a powerful advertising feature that
                allows businesses like yours to connect with potential customers
                instantly through WhatsApp. By displaying an ad with a "Click to
                WhatsApp" button, you can start a conversation directly from
                platforms like Facebook or Instagram. This makes it easier for
                you to engage with your leads in real time. 
              </motion.p>
            </div>
          </div>
        </div>
      </section>
      <section className={classes.benefitSection2}>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-56 font-white"
            >
              Benefits of AI CRM for customer support
            </motion.h2>
            <motion.p
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-regular font-18 font-white"
            >
              Click-to-WhatsApp ads let businesses start real-time conversations
              instantly, creating a personalised and direct connection. This
              boosts engagement, builds trust, and drives higher conversions.
            </motion.p>
          </div>
          <div className={classes.benefitContainer}>
            {benefits.map((benefit) => (
              <div className={classes.benefitBox}>
                <img
                  src={benefit.icon}
                  alt="Connect with sales via WhatsApp."
                />
                <p className="font-wix-semibold font-24 font-white">
                  {benefit.title}
                </p>
                <p className="font-wix-regular font-18 font-white">
                  {benefit.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className={classes.accordianTabs}>
        <div className="container">
          <div className="headercenterContainer">
            <motion.h2
              className="font-wix-semibold font-56 text-black1"
              initial={{ opacity: 1, y: 20 }}
              transition={{ duration: 0.3 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              Pepper Cloud the best tool for Click-to-WhatsApp ads
            </motion.h2>
            <p className="font-18 font-wix-regular text-black2">
              Pepper Cloud is the ideal platform to manage Click-to-WhatsApp
              ads. It streamlines lead capture, engagement, and conversion
              tracking, all within your CRM.
            </p>
          </div>
          <div className={classes.experienceInnerContainer}>
            <div className={classes.experienceContainerLeft} ref={sectionRef}>
              {experienceList.map((faq, index) => (
                <motion.div
                  className={clsx(
                    classes.faqBoxAccordian,
                    index === activeAccordian && "active",
                    "text-color2"
                  )}
                  key={`faq-${index}`}
                  onClick={() => handleAccordionClick(index)}
                  transition={{ duration: 1, delay: index * 0.01 }}
                  whileInView={{ opacity: [0, 1], y: [50, 0] }}
                >
                  <div className={classes.experienceHeader}>
                    <h3 className="font-20 font-wix-semibold">{faq.title}</h3>
                    <p className="font-18 font-wix-regular color-black2 exp-desc">
                      {faq.desc}
                    </p>
                  </div>

                  <Collapse
                    className={classes.collapseBody}
                    in={activeAccordian === index}
                  >
                    <p className="font-18 font-wix-regular color-black2 exp-desc">
                      {faq.desc}
                    </p>
                    <motion.img
                      alt={faq.alt}
                      initial={{ opacity: 1, y: 20 }}
                      src={faq.img}
                      transition={{ duration: 0.3 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      style={{
                        backgroundImage: `url(${faq.bgImg})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                      }}
                    />
                  </Collapse>
                </motion.div>
              ))}
            </div>
            <div className={classes.experienceContainerRight}>
              {experienceList.map(
                (experience, index) =>
                  index === activeAccordian && (
                    <div
                      className="rightContent"
                      style={{
                        backgroundImage: `url(${experience.bgImg})`, // pass your image URL in experience.bgImage
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                      }}
                    >
                      <motion.img
                        src={experience.img}
                        initial={{ opacity: 0, x: 50 }} // start 50px left, invisible
                        whileInView={{ opacity: 1, x: 0 }} // animate to normal position
                        transition={{ duration: 0.6, ease: "easeOut" }}
                        viewport={{ once: true, amount: 0.2 }} // trigger when 20% visible, only once
                      />
                      <motion.p
                        className="font-18 font-wix-regular"
                        initial={{ opacity: 0, x: -50 }} // start 50px left, invisible
                        whileInView={{ opacity: 1, x: 0 }} // animate to normal position
                        transition={{ duration: 0.6, ease: "easeOut" }}
                        viewport={{ once: true, amount: 0.2 }} // trigger when 20% visible, only once
                      >
                        {experience.desc}
                      </motion.p>
                    </div>
                  )
              )}
            </div>
          </div>
        </div>
      </section>
      <section className={classes.combineSection}>
        <div className={classes.integrationContent}>
          <motion.h2
            className="font-wix-semibold font-56 color-white"
            initial={{ opacity: 1, y: 20 }}
            transition={{ duration: 0.3 }}
            whileInView={{ opacity: 1, y: 0 }}
          >
            Pepper Cloud CRM features tailored for business success
          </motion.h2>
        </div>

        <section className="sales-dev-logo-carousel">
          <div className="logos-container">
            <div className="scroll-container">
              <div className="logos-row" data-direction="left" data-speed="0.8">
                <div className="logos-track">
                  {logotrack1.map((logo) => (
                    <div
                      className="logo font-18 font-wix-medium"
                      key={logo.title}
                    >
                      <img alt={`${logo.title} integration`} src={logo.img} />
                      <p>{logo.title}</p>
                    </div>
                  ))}
                </div>
              </div>

              <div
                className="logos-row"
                data-direction="right"
                data-speed="0.4"
              >
                <div className="logos-track">
                  {logotrack2.map((logo) => (
                    <div className="logo font-18 font-wix-medium">
                      <img alt={`${logo.title} integration`} src={logo.img} />
                      <p>{logo.title}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className={classes.absoulteCard}>
          <TruestedSection shadow background={true} />
        </div>
      </section>
      <section className={classes.realWorldTabs}>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              className="font-wix-semibold font-56 color-black1"
              initial={{ opacity: 1, y: 20 }}
              transition={{ duration: 0.3 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              Applications and use cases of Click-to-WhatsApp ads
            </motion.h2>
            <div className={classes.tabsContainer}>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-semibold",
                  "font-18",
                  activeRealWorld === 0 && "active"
                )}
                onClick={() => setActiveRealWorld(0)}
              >
                E-commerce and Retail
              </div>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-semibold",
                  "font-18",
                  activeRealWorld === 1 && "active"
                )}
                onClick={() => setActiveRealWorld(1)}
              >
                Healthcare and Wellness
              </div>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-semibold",
                  "font-18",
                  activeRealWorld === 2 && "active"
                )}
                onClick={() => setActiveRealWorld(2)}
              >
                Travel and Hospitality
              </div>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-semibold",
                  "font-18",
                  activeRealWorld === 3 && "active"
                )}
                onClick={() => setActiveRealWorld(3)}
              >
                Financial Services
              </div>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-semibold",
                  "font-18",
                  activeRealWorld === 4 && "active"
                )}
                onClick={() => setActiveRealWorld(4)}
              >
                Education
              </div>
            </div>
          </div>

          <div className={classes.tabCard}>
            <div className={classes.tabCardLeftContainer}>
              {tabContentData.map(
                (listItem, index) =>
                  index === activeRealWorld && (
                    <div>
                      <motion.p
                        className="font-wix-regular font-18 color-black2"
                        initial={{ opacity: 0, y: 20 }}
                        transition={{ duration: 0.3 }}
                        whileInView={{ opacity: 1, y: 0 }}
                      >
                        {listItem.subtitle}
                      </motion.p>
                      <div className={classes.benfitListContainer}>
                        {listItem.tabContent.map((item) => (
                          <motion.div
                            className={classes.benfitListItem}
                            initial={{ opacity: 0, y: 20 }}
                            transition={{ duration: 0.3 }}
                            whileInView={{ opacity: 1, y: 0 }}
                          >
                            <LazyImage
                              alt={item.alt}
                              className={classes.benfitIcon}
                              source={bannerTick}
                            />
                            <div className={classes.benfitListItemContent}>
                              <p className="font-wix-semibold font-20 color-black1">
                                {item.heading}
                              </p>
                              <p className="font-wix-regular font-18 color-black2">
                                {item.content}
                              </p>
                            </div>
                          </motion.div>
                        ))}
                      </div>
                    </div>
                  )
              )}
            </div>
            <div className={classes.tabCardRightContainer}>
              {tabContentData.map(
                (listItem, index) =>
                  index === activeRealWorld && (
                    <motion.div
                      initial={{ opacity: 1, y: 20 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.3 }}
                      // className={classes.aiSectionRight}
                    >
                      <LazyImage
                        alt={listItem.alt}
                        source={listItem.image}
                        width={"100%"}
                      />
                    </motion.div>
                  )
              )}
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className="container">
          <div className="header">
            <motion.h2
              className="font-wix-semibold font-56 font-black1"
              initial={{ opacity: 1, y: 20 }}
              transition={{ duration: 0.3 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              5 Best software for Click-to-WhatsApp ads in 2025
            </motion.h2>
          </div>
          <div className={classes.compareSectionContainer}>
            <div className={classes.compareSectionContainerLeftSection}>
              {compareItems.map((item, index) => (
                <div
                  className={clsx(
                    classes.compareSectionLeftItem,
                    activeCompare === `#section${index}` && "active"
                  )}
                  onClick={() => {
                    scrollToSection(`#section${index}`);
                    setActiveCompare(`#section${index}`);
                  }}
                >
                  <a
                    className={clsx(
                      "font-22 font-wix-medium font-black1",
                      activeCompare === `#section${index}` &&
                        "font-wix-semibold"
                    )}
                    href={`#section${index}`}
                  >
                    {item}
                  </a>
                </div>
              ))}
            </div>
            <div className={classes.compareSectionContainerRightSection}>
              {compareData.map((data, outerIndex) => (
                <div
                  className={classes.compareItemContainer}
                  id={`#section${outerIndex}`}
                >
                  <h3
                    className="font-40 font-wix-semibold font-black1"
                    initial={{ opacity: 1, y: 20 }}
                    transition={{ duration: 0.3 }}
                    whileInView={{ opacity: 1, y: 0 }}
                  >
                    {data.title}
                  </h3>
                  <p
                    className="font-wix-regular font-18 font-black1"
                    initial={{ opacity: 1, y: 20 }}
                    transition={{ duration: 0.3 }}
                    whileInView={{ opacity: 1, y: 0 }}
                  >
                    {data.desc}
                  </p>
                  <img alt={data.alt} className="productImage" src={data.img} />
                  <div className={classes.faqsContainer}>
                    {data.features.map((faq, innerIndex) => (
                      <motion.div
                        className={classes.faqBox}
                        onClick={() =>
                          setActiveAccordian(
                            `${outerIndex}-${innerIndex}` === activeAccordian
                              ? -1
                              : `${outerIndex}-${innerIndex}`
                          )
                        }
                        transition={{ duration: 1, delay: innerIndex * 0.01 }}
                        whileInView={{ opacity: [0, 1], y: [50, 0] }}
                      >
                        <div className={classes.topFiveHeader}>
                          <h3 className="font-20 font-wix-semibold">
                            {faq.title}
                          </h3>
                          <img
                            alt="Arrow"
                            className={clsx(
                              classes.downArrow,
                              `${outerIndex}-${innerIndex}` ===
                                activeAccordian && "active"
                            )}
                            src={downArrow}
                          />
                        </div>
                        <Collapse
                          className={classes.body}
                          in={activeAccordian === `${outerIndex}-${innerIndex}`}
                        >
                          <p className="font-18 font-wix-regular color-black2">
                            {faq.desc}
                          </p>
                        </Collapse>
                      </motion.div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      <div className={classes.testimonials}>
        <TestimonialSlider
          desc={
            "Discover how businesses are transforming customer engagement with Pepper Cloud."
          }
          heading={"Real stories. Real results."}
          noButton={true}
        />
      </div>
      <div className={classes.wpFaq}>
        <FaqSection
          backgroundColor={"#FFF8F5"}
          faqs={faqs}
          heading={"Click-to-WhatsApp ads- FAQs"}
        />
      </div>
      <section className={classes.commonPageFooterSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              className="font-wix-medium font-56 font-white"
              initial={{ opacity: 1, y: 30 }}
              transition={{ duration: 0.5 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              Turn clicks into conversations in an instant
            </motion.h2>
            <Link
              className="primaryButton font-20 font-wix-medium font-white"
              to="/contact/?utm_source=WhatsApp+CRM&utm_medium=Get+started"
            >
              Get started
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default clickToWhatsAppAds;
